import type { Conversation } from "@mirage/service-conversation/types";
import { atom, useAtom } from "jotai";
import { useEffect } from "react";

export const conversationPageLoadingAtom = atom<boolean>(false);

export function useConversationPageLoadingStates(
  conversation: Conversation | undefined,
  conversationId: string | undefined,
) {
  const [isConversationPageLoading, setIsConversationPageLoading] = useAtom(
    conversationPageLoadingAtom,
  );
  // Set loading state when conversationId changes
  useEffect(() => {
    if (conversationId) {
      setIsConversationPageLoading(true);
    }
  }, [conversationId, setIsConversationPageLoading]);

  // Set loading state when conversation changes
  useEffect(() => {
    if (conversation) {
      setIsConversationPageLoading(false);
    }
  }, [conversation, setIsConversationPageLoading]);

  return {
    isConversationPageLoading,
    setIsConversationPageLoading,
  };
}
